import { Chip, Typography } from "@mui/material";
import { Box } from "@mui/system";

interface ParameterProps {
    parameterName: string;
    parameter: any;
    required: boolean;
}

export const Parameter: React.FC<ParameterProps> = ({ parameterName, parameter, required }) => {

    const getParameterTypeColor = (type: string) => {
            const colors: Record<string, 'default' | 'primary' | 'secondary'> = {
                string: 'default',
                number: 'primary',
                boolean: 'secondary',
                file: 'primary'
            };
            return colors[type] || 'default';
        };

    return (
        <Box
            sx={{
                p: 1.5,
                flexShrink: 0,
                width: '16rem',
                border: '1px solid',
                borderColor: 'divider',
                display: 'flex',
                borderRadius: 1,
                flexDirection: 'column',
                gap: 0.5,
                backgroundColor: 'background.paper'
            }}>
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                flexWrap: 'wrap'
            }}>
                <Typography variant="body2">
                    {parameterName}
                </Typography>
                <Chip
                    label={parameter.type}
                    color={getParameterTypeColor(parameter.type)}
                    size="small"
                    sx={{ fontSize: '0.6rem', height: 16 }}
                />
                {required && (
                    <Chip
                        label="required"
                        size="small"
                        sx={{
                            fontSize: '0.6rem',
                            height: 16,
                            backgroundColor: 'error.light',
                            color: 'white',
                        }}
                    />
                )}
            </Box>
            <Typography
                variant="body2"
                fontSize="0.8rem"
                color="text.secondary">
                {parameter.description}
            </Typography>
        </Box>
    );
};